module.exports = __webpack_public_path__ + "static/media/Grandpop's Uke.f9921600.mp3";